/**
 * @typedef {'idle'|'reauthenticating'|'stamping'|'completed'|'error'} SignerUiState
 *
 * @typedef {Object} StampPlacement
 * @property {number} page 1-based page index
 * @property {number} xPct 0-100 from left
 * @property {number} yPct 0-100 from top
 *
 * @typedef {Object} SignerMetaData
 * @property {string} role
 * @property {string} signerName
 * @property {string} [signerTitle]
 * @property {string} [signerEmail]
 * @property {string} [decision]
 * @property {'draw'|'text'} signatureType
 * @property {string} signatureData PNG base64 for 'draw', typed name for 'text'
 * @property {StampPlacement} placement
 * @property {string} reauthProof
 * @property {string} [reauthJti]
 * @property {string} [reauthVerifiedAt] ISO timestamp
 */

export const SIGNER_UI_STATES = {
  IDLE: 'idle',
  REAUTHENTICATING: 'reauthenticating',
  STAMPING: 'stamping',
  COMPLETED: 'completed',
  ERROR: 'error',
}

export default SIGNER_UI_STATES
